{
  "version": 1,
  "asset_id": "472aa125-57be-4c4a-92df-30dab46bb0ef",
  "project_id": "1203040e-940d-4f2e-ab5b-8733ed2d3c31",
  "url": "/__l5e/assets-v1/472aa125-57be-4c4a-92df-30dab46bb0ef/opt_metodo-4.jpg",
  "r2_key": "a/v1/1203040e-940d-4f2e-ab5b-8733ed2d3c31/472aa125-57be-4c4a-92df-30dab46bb0ef/opt_metodo-4.jpg",
  "original_filename": "opt_metodo-4.jpg",
  "size": 108633,
  "content_type": "image/jpeg",
  "created_at": "2026-08-26T20:33:34Z"
}
